import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./EndFooter.css";

const cardData = [
  { id: 1, title: "Care Taker" },
  { id: 2, title: "Senior Citizen Care" },
  { id: 3, title: "Colostomy Care" },
  { id: 4, title: "Bedridden Patient Care" },
  { id: 5, title: "All Injections" },
  { id: 6, title: "Wound Dressing" },
  { id: 7, title: "Cancer Care" },
  { id: 8, title: "Post Surgical Caree" },
  { id: 9, title: "Catheter Care " },
  { id: 10, title: "Tracheostomy Care" },
  { id: 11, title: "Psychiatric Care" },
  { id: 12, title: "Stroke Care" },
  { id: 13, title: "Physiotheraphy Care" },
  { id: 14, title: "Hospital Attender" },
  { id: 15, title: "Cooking Services" },
  { id: 16, title: "Cleaning Services" },
];

const EndFooter = () => {
  return (
    <footer className="endfooter text-white py-4">
      <Container>
        <h4 className="endfooter-title text-center mb-3 ">
          Our Services At Your Home
        </h4>
        <Row>
          {cardData.map((service) => (
            <Col key={service.id} xs={6} sm={4} md={3} lg={2} className="mb-3">
              <a
                href="/ourservices"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className="endfooter-service text-center p-2 border rounded">
                  {service.title}
                </div>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </footer>
  );
};

export default EndFooter;
